<template>
    <div>
        <!-- Loading spinner / skeleton -->
        <div v-if="publications.length == 0 && !error_message" class="loading-skeleton">
            <div class="loader-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
            <!-- Blurred background skeleton content -->
            <!-- <div class="skeleton-content">
                <ul class="KARpublications">
                    <template v-for="pub in skeleton_data">
                        <publication :publication="pub" :key="pub.id"></publication>
                    </template>
                </ul>
                <div class="gradient-overlay"></div>
            </div> -->
        </div>
        <!-- Error message -->
        <div class="kar-error" v-if="error_message">
            <p>{{ error_message }}</p>
            <button v-if="error_message != 'No publications found'" @click="call_the_API" class="button button--hero" style="margin: 20px auto;display: block;">
                Reload
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="display: inline-block;margin-left: 10px;margin-bottom: -3px;height: 20px;">
                    <path fill="white" d="M13.5 2c-5.629 0-10.212 4.436-10.475 10h-3.025l4.537 5.917 4.463-5.917h-2.975c.26-3.902 3.508-7 7.475-7 4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5c-2.381 0-4.502-1.119-5.876-2.854l-1.847 2.449c1.919 2.088 4.664 3.405 7.723 3.405 5.798 0 10.5-4.702 10.5-10.5s-4.702-10.5-10.5-10.5z"/>
                </svg>
            </button>
        </div>
        <!-- Main KAR panel publication listing -->
        <p v-if="publications.length > noToDisplay">
            <a class="KARExternal" :href="link" target="_blank">View all publications</a>.
        </p>
        <!-- People profile publication listing -->
        <template v-else-if="publications.length > 0 && people_profile">
            <div v-for="(type, name) in peoplePublications" :key="name">
                <div v-if="type.length > 0">
                    <h3>{{ name }}</h3>
                    <ul class="kar__list">
                        <template v-for="pub in type">
                            <card :publication="pub" :key="pub.id"></card>
                        </template>
                    </ul>
                </div>
            </div>
        </template>
        <!-- KAR panel publication listing -->
        <template v-else-if="publications.length > 0">
            <h3 v-if="publication_type_title">{{ publication_type_title }}</h3>
            <ul class="kar__list">
                <template v-for="pub in publications">
                    <card :publication="pub" :key="pub.id"></card>
                </template>
            </ul>
        </template>
        <!-- Pagination -->
        <div v-if="!people_profile && !error_message" class="KARpaginator">
            <ul>
                <li>
                    <button
                        @click="go_to_previous_page"
                        :disabled="page_number <= 1"
                        :class="{disabled: page_number <= 1}"
                    >&lt;</button>
                </li>
                <template v-if="last_page <= maximum_no_pages">
                    <li v-for="page in last_page" :key="page">
                        <button @click="set_page_number(page)" :class="{active: page_number === page}">{{page}}</button>
                    </li>
                </template>
                <template v-else>
                    <template v-if="near_start === false">
                        <button 
                            @click="set_page_number(1)" 
                            :class="{active: page_number === page}"
                            aria-label="First page - 1"
                            >1</button>
                        <!-- <button 
                            @click="set_page_number('l')" 
                            :class="{active: page_number === page}"
                            :aria-label=""
                            >...</button> -->
                    </template>
                    <li v-for="page in pageArray" :key="page">
                        <button 
                            @click="set_page_number(page)" 
                            :class="{active: page_number === page}"
                            :aria-label="page"
                            >{{page}}</button>
                    </li>
                    <template v-if="near_end === false">
                        <!-- <button 
                            @click="set_page_number('r')" 
                            :class="{active: page_number === page}"
                            :aria-label=""
                            >...</button> -->
                        <button
                            @click="set_page_number(last_page)"
                            :class="{active: page_number === page}"
                            :aria-label="'Last page - '+this.last_page"
                            >{{this.last_page}}</button>
                    </template>
                </template>
            </ul>
        </div>
        <!-- Limit dropdown -->
        <div v-if="!people_profile && error_message != 'No publications found'" class="filter__select_div" style="margin:auto !important; padding-bottom:15px;">
            <label id="sort-by-label">Number of publications per page:</label>
            <select
                v-model="selected"
                id="sort-by-dropdown"
                class="custom-select group-search form-control show-dropdown"
                aria-labelledby="sort-by-label"
                @change="update_limit(selected)"
            >
                <option value disabled hidden>{{noToDisplay}}</option>
                <option value="10">10</option>
                <option value="15">15</option>
                <option value="20">20</option>
                <option value="25">25</option>
            </select>
        </div>
        <!-- Footer links -->
        <div v-if="error_message != 'No publications found'" class="KARfooter">
            <p>
                Information obtained from the
                <a class="KARExternal" href="http://kar.kent.ac.uk/">Kent Academic Repository</a>, University of Kent's official repository of academic activity.
                <a class="KARExternal" href="https://www.kent.ac.uk/library/research/kar/">Find out more about the Kent Academic Repository</a>.
            </p>
            <p>Names marked in <strong style="color:#005689;">bold</strong> are University of Kent authors. Click on the authors name to view more publications from them on the <a class="KARExternal" href="http://kar.kent.ac.uk/">Kent Academic Repository</a></p>
            <p v-if="publications.length > noToDisplay">
                The list of publications above shows {{noToDisplay}} of {{publications.length}} total publications in KAR.
                <a v-if="show_link" class="KARExternal" :href="link">View all publications in the Kent Academic Repository</a>
            </p>
            <p v-else>
                <a v-if="show_link" class="KARExternal" :href="link">View all publications listed above in the Kent Academic Repository</a>.
            </p>
            <p v-if="!show_link">
                <a class="KARExternal" href="https://kar.kent.ac.uk/cgi/search/advanced">Try an Advanced Search on the Kent Academic Repository</a>.
            </p>            
        </div>
    </div>
</template>

<script>
import Card from "./card.vue";

export default {
    components: {
        'card': Card
    },
    props: {
        panel_number: Number,
        division: Array,
        authors: Array,
        signature_theme: Array,
        taxonomies: Array,
        publication_type: Array,
        citation_style: String,
        limit: Number,
        sort: String,
        people_profile: Boolean
    },
    data() {
        return {
            fetch_url: '',
            fetch_parameters: {},
            page_number: 1,
            last_page: 1,
            offset: 0,
            maximum_no_pages: 10,
            near_end: false,
            near_start: true,
            publications: [],
            peoplePublications: {
                "Article":[],
                "Book":[],
                "Audio":[],
                "Book section":[],
                "Conference or workshop item":[],
                "Datasets / databases":[],
                "Edited book":[],
                "Edited journal":[],
                "Show / exhibition":[],
                "Experiment":[],
                "Image":[],
                "Monograph":[],
                "Other":[],
                "Patent":[],
                "Performance":[],
                "Research report (external)":[],
                "Review":[],
                "Scholarly edition":[],
                "Thesis":[],
                "Internet publication":[],
                "Visual media":[]
            },
            error_message: "",
            selected: "",
            publication_type_title: null,
            link: "",
            show_link: true,
            skeleton_data: [{"id":91650,"abstract":"Employing a realistic tight-binding model describing the Fermi surface in the normal state of \\(Sr_2RuO_4\\) we map out magnetic field versus temperature phase diagrams for \\(d_{x2−y2}(B_{1g})\\) and \\(d_{xz}+id_{yz}(E_g)\\) pairing types. Both produce (i) a similar Knight shift suppression of ∼80% and (ii) a bicritical point at \\(T=0.88K\\) separating low field second order phase transitions from high field Pauli limiting first order transitions. We find, however, strikingly different phase behaviour within the high field Pauli limiting region. For \\(d_{x2−y2}\\) pairing symmetry an additional lower critical line of first order transitions is found (terminating in a critical point at \\(T=0.09−0.22K\\) depending on the choice of Hubbard U parameters) while for \\(d_{xz}+id_{yz}\\) no such additional high field phase transitions are found for any choice of Hubbard U. In conjunction with our earlier finding [{\\it Physical Review B} {\\bf 102} (23), 235203] for \\(p\\)-wave helical pairing of a still different high field phase structure (a lower critical field line meeting the upper critical field line exactly at the bicritical point), we suggest high field Pauli limiting phase structure as a possible route to distinguish pairing symmetries in this material.","file":false,"file_type":false,"kar_url":"https://kar.kent.ac.uk/91650","authors":[{"given":"R.","family":"Gupta","email":"reena.gupta027@gmail.com","url":"https://kar.kent.ac.uk/view/email/reena=2Egupta027=40gmail=2Ecom.html"},{"given":"S.","family":"Shallcross","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"J.","family":"Quintanilla","email":"j.quintanilla@kent.ac.uk","url":"https://kar.kent.ac.uk/view/email/j=2Equintanilla=40kent=2Eac=2Euk.html"},{"given":"M.","family":"Gradhand","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"J.","family":"Annett","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"}],"citations":{"APA":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Gupta, R., Shallcross, S., Quintanilla, J., Gradhand, M., &#38; Annett, J. (2021). Distinguishing \\(d_{xz}+id_{yz}\\) and \\(d_{x2−y2}\\) pairing in \\(Sr_2RuO_4\\) by high magnetic field H-T phase diagrams. <i>ArXiv</i>. Retrieved from https://arxiv.org/abs/2111.00257</div>\n</div>","HARVARD":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Gupta, R., Shallcross, S., Quintanilla, J., Gradhand, M. and Annett, J. (2021) “Distinguishing \\(d_{xz}+id_{yz}\\) and \\(d_{x2−y2}\\) pairing in \\(Sr_2RuO_4\\) by high magnetic field H-T phase diagrams”, <i>arXiv</i>. Available at: https://arxiv.org/abs/2111.00257.</div>\n</div>","IEEE":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\"><div class=\"csl-left-margin\">[1]</div><div class=\"csl-right-inline\">R. Gupta, S. Shallcross, J. Quintanilla, M. Gradhand, and J. Annett, “Distinguishing \\(d_{xz}+id_{yz}\\) and \\(d_{x2−y2}\\) pairing in \\(Sr_2RuO_4\\) by high magnetic field H-T phase diagrams”, <i>arXiv</i>. 2021 [Online]. Available: https://arxiv.org/abs/2111.00257</div></div>\n</div>","CHICAGO":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Gupta, R., S. Shallcross, J. Quintanilla, M. Gradhand, and J. Annett. 2021. “Distinguishing \\(d_{xz}+id_{yz}\\) and \\(d_{x2−y2}\\) Pairing in \\(Sr_2RuO_4\\) by High Magnetic Field H-T Phase Diagrams”. <i>ArXiv</i>. https://arxiv.org/abs/2111.00257.</div>\n</div>"}},{"id":91828,"abstract":"When the transition temperature of a continuous phase transition is tuned to absolute zero, new ordered phases and physical behaviour emerge in the vicinity of the resulting quantum critical point. Sr\\(_3\\)Ru\\(_2\\)O\\(_7\\) can be tuned through quantum criticality with magnetic field at low temperature. Near its critical field \\(B\\)\\(_c\\) it displays the hallmark \\(T\\)-linear resistivity and a \\(T\\)log(1/\\(T\\)) electronic heat capacity behaviour of strange metals. However, these behaviours have not been related to any critical fluctuations. Here we use inelastic neutron scattering to reveal the presence of collective spin fluctuations whose relaxation time and strength show a nearly singular variation with magnetic field as \\(B\\)\\(_c\\) is approached. The large increase in the electronic heat capacity and entropy near \\(B\\)\\(_c\\) can be understood quantitatively in terms of the scattering of conduction electrons by these spin-fluctuations. On entering the spin-density-wave ordered phase present near \\(B\\)\\(_c\\), the fluctuations become stronger suggesting that the order is stabilised through an “order-by-disorder” mechanism.","file":false,"file_type":false,"kar_url":"https://kar.kent.ac.uk/91828","authors":[{"given":"C.","family":"Lester","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"S.","family":"Ramos","email":"s.ramos-perez@kent.ac.uk","url":"https://kar.kent.ac.uk/view/email/s=2Eramos-perez=40kent=2Eac=2Euk.html"},{"given":"R. S.","family":"Perry","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"T. P.","family":"Croft","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"M.","family":"Laver","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"R. I.","family":"Bewley","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"T.","family":"Guidi","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"A.","family":"Hiess","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"A.","family":"Wildes","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"E. M.","family":"Forgan","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"},{"given":"S. M.","family":"Hayden","email":null,"url":"https://kar.kent.ac.uk/view/email/.html"}],"citations":{"APA":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Lester, C., Ramos, S., Perry, R. S., Croft, T. P., Laver, M., Bewley, R. I., Guidi, T., Hiess, A., Wildes, A., Forgan, E. M., &#38; Hayden, S. M. (2021). Magnetic-field-controlled spin fluctuations and quantum criticality in Sr\\(_3\\)Ru\\(_2\\)O\\(_7\\). <i>Nature Communications</i>, <i>12</i>. doi:10.1038/s41467-021-26068-3</div>\n</div>","HARVARD":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Lester, C., Ramos, S., Perry, R. S., Croft, T. P., Laver, M., Bewley, R. I., Guidi, T., Hiess, A., Wildes, A., Forgan, E. M. and Hayden, S. M. (2021) “Magnetic-field-controlled spin fluctuations and quantum criticality in Sr\\(_3\\)Ru\\(_2\\)O\\(_7\\)”, <i>Nature Communications</i>. Nature Research. doi: 10.1038/s41467-021-26068-3.</div>\n</div>","IEEE":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\"><div class=\"csl-left-margin\">[1]</div><div class=\"csl-right-inline\">C. Lester, S. Ramos, R. S. Perry, T. P. Croft, M. Laver, R. I. Bewley, T. Guidi, A. Hiess, A. Wildes, E. M. Forgan, and S. M. Hayden, “Magnetic-field-controlled spin fluctuations and quantum criticality in Sr\\(_3\\)Ru\\(_2\\)O\\(_7\\)”, <i>Nature Communications</i>, vol. 12. Nature Research, 2021 [Online]. Available: https://doi.org/10.1038/s41467-021-26068-3</div></div>\n</div>","CHICAGO":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Lester, C., S. Ramos, R. S. Perry, T. P. Croft, M. Laver, R. I. Bewley, T. Guidi, A. Hiess, A. Wildes, E. M. Forgan, and S. M. Hayden. 2021. “Magnetic-Field-Controlled Spin Fluctuations and Quantum Criticality in Sr\\(_3\\)Ru\\(_2\\)O\\(_7\\)”. <i>Nature Communications</i>. Nature Research. doi:10.1038/s41467-021-26068-3.</div>\n</div>"}},{"id":92347,"abstract":"The Hofstadter model is a popular choice for theorists investigating the fractional quantum Hall effect on lattices, due to its simplicity, infinite selection of topological flat bands, and increasing applicability to real materials. In particular, fractional Chern insulators in bands with Chern number |C|>1 can demonstrate richer physical properties than continuum Landau level states and have recently been detected in experiments. Motivated by this, we examine the stability of fractional Chern insulators with higher Chern number in the Hofstadter model, using large-scale infinite density matrix renormalization group simulations on a thin cylinder. We confirm the existence of fractional states in bands with Chern numbers C=1,2,3,4,5 at the filling fractions predicted by the generalized Jain series [Phys. Rev. Lett. 115, 126401 (2015)]. Moreover, we discuss their metal-to-insulator phase transitions, as well as the subtleties in distinguishing between physical and numerical stability. Finally, we comment on the relative suitability of fractional Chern insulators in higher Chern number bands for proposed modern applications.","file":false,"file_type":false,"kar_url":"https://kar.kent.ac.uk/92347","authors":[{"given":"Bartholomew","family":"Andrews","email":"bandrews@physics.ucla.edu","url":"https://kar.kent.ac.uk/view/email/bandrews=40physics=2Eucla=2Eedu.html"},{"given":"Titus","family":"Neupert","email":"titus.neupert@uzh.ch","url":"https://kar.kent.ac.uk/view/email/titus=2Eneupert=40uzh=2Ech.html"},{"given":"Gunnar","family":"Möller","email":"g.moller@kent.ac.uk","url":"https://kar.kent.ac.uk/view/email/g=2Emoller=40kent=2Eac=2Euk.html"}],"citations":{"APA":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Andrews, B., Neupert, T., &#38; Möller, G. (2021). Stability, phase transitions, and numerical breakdown of fractional Chern insulators in higher Chern bands of the Hofstadter model. <i>Physical Review B: Condensed Matter and Materials Physics</i>, <i>104</i>. doi:10.1103/PhysRevB.104.125107</div>\n</div>","HARVARD":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Andrews, B., Neupert, T. and Möller, G. (2021) “Stability, phase transitions, and numerical breakdown of fractional Chern insulators in higher Chern bands of the Hofstadter model”, <i>Physical Review B: Condensed Matter and Materials Physics</i>. American Physical Society. doi: 10.1103/PhysRevB.104.125107.</div>\n</div>","IEEE":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\"><div class=\"csl-left-margin\">[1]</div><div class=\"csl-right-inline\">B. Andrews, T. Neupert, and G. Möller, “Stability, phase transitions, and numerical breakdown of fractional Chern insulators in higher Chern bands of the Hofstadter model”, <i>Physical Review B: Condensed Matter and Materials Physics</i>, vol. 104. American Physical Society, 2021 [Online]. Available: https://journals.aps.org/prb/abstract/10.1103/PhysRevB.104.125107</div></div>\n</div>","CHICAGO":"<div class=\"csl-bib-body\">\n  <div class=\"csl-entry\">Andrews, Bartholomew, Titus Neupert, and Gunnar Möller. 2021. “Stability, Phase Transitions, and Numerical Breakdown of Fractional Chern Insulators in Higher Chern Bands of the Hofstadter Model”. <i>Physical Review B: Condensed Matter and Materials Physics</i>. American Physical Society. doi:10.1103/PhysRevB.104.125107.</div>\n</div>"}}]
        };
    },
    computed: {
        pageArray() {
            let pages = [];
            let startPage = 0,
                endPage = 0;
            let maximum_no_pages_before_current_page = Math.floor(this.maximum_no_pages / 2);
            let maximum_no_pages_after_current_page = Math.ceil(this.maximum_no_pages / 2) - 1;
            if (this.page_number <= maximum_no_pages_before_current_page + 1) {
                // Current page is near the start
                startPage = 1;
                endPage = this.maximum_no_pages - 2;
                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }
                this.set_is_start(true);
                this.set_is_end(false);
                return pages;
            } else if (this.page_number + maximum_no_pages_after_current_page >= this.last_page) {
                // Current page is near the end
                startPage = this.last_page - this.maximum_no_pages + 3;
                endPage = this.last_page;
                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }
                this.set_is_start(false);
                this.set_is_end(true);
                return pages;
            } else {
                // Current page is somewhere in the middle
                startPage = this.page_number - maximum_no_pages_before_current_page + 2;
                endPage = this.page_number + maximum_no_pages_after_current_page - 2;
                for (let i = startPage; i <= endPage; i++) {
                    pages.push(i);
                }
                this.set_is_start(false);
                this.set_is_end(false);
                return pages;
            }
        },
        searchOnParam() {
            return this.searchOn !== "" ? this.searchOn + "/" : this.searchOn;
        }
    },
    methods: {
        call_the_API() {
            
            // The link is visible before
            this.generate_link();

            this.publications = [];

            this.offset = this.page_number * this.limit;

            // Fetch publications from the Kent API based on the selected options
            this.fetch_url = 'https://api.kent.ac.uk/api/v1/kar/search';
            this.fetch_parameters = {
                "limit": this.limit,
                "page": this.page_number,
                "sort": this.sort,
            };

            if(this.division && this.division.use){
                this.fetch_parameters["divisions"] = this.division.values;
                this.fetch_parameters["divisions.match"] = this.division.match;
                this.fetch_parameters["divisions.merge"] = this.division.merge;
            }

            if(this.authors && this.authors.use) {
                if(this.authors.type == 'email') {
                    this.fetch_parameters["email"] = this.authors.values;
                    this.fetch_parameters["email.match"] = this.authors.match;
                    this.fetch_parameters["email.merge"] = this.authors.merge;
                } else if(this.authors.type == 'orcid') {
                    this.fetch_parameters["orcid"] = this.authors.values;
                    this.fetch_parameters["orcid.match"] = this.authors.match;
                    this.fetch_parameters["orcid.merge"] = this.authors.merge;
                }
            }

            if(this.signature_theme && this.signature_theme.use){
                this.fetch_parameters["signature_theme"] = parseInt(this.signature_theme.value);
                this.fetch_parameters["signature_theme.match"] = this.signature_theme.match;
                this.fetch_parameters["signature_theme.merge"] = this.signature_theme.merge;
            }
    
            // if(this.taxonomies && this.taxonomies.uncontrolled_keywords.use){
            //     this.fetch_parameters["keywords"] =  this.taxonomies.uncontrolled_keywords.value;
            //     this.fetch_parameters["keywords.match"] = this.taxonomies.uncontrolled_keywords.match;
            //     this.fetch_parameters["keywords.merge"] = this.taxonomies.uncontrolled_keywords.merge;
            // }

            if(this.taxonomies && this.taxonomies.kent_web_tag.use){
                this.fetch_parameters["tags"] = parseInt(this.taxonomies.kent_web_tag.value);
                this.fetch_parameters["tags.match"] = this.taxonomies.kent_web_tag.match;
                this.fetch_parameters["tags.merge"] = this.taxonomies.kent_web_tag.merge;
            }

            if(!this.people_profile) {
                if(this.publication_type && this.publication_type.value.length > 0) {
                    this.fetch_parameters["type"] =  this.publication_type.value;
                    this.fetch_parameters["type.match"] = this.publication_type.match;
                    this.fetch_parameters["type.merge"] = this.publication_type.merge;
                }
            }

            fetch(this.fetch_url,
            {
                cache: 'no-cache', 
                method: 'POST',
                body: JSON.stringify(this.fetch_parameters)
            })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw new Error("Failed to fetch from KAR");
                }
            })
            .then(data => {
                // If no publications found
                if (data.found === 0) {
                    this.error_message = "No publications found";
                }
                else if (data.publications && this.people_profile) {
                    this.publications = data.publications;
                    this.last_page = data.last_page;

                    for(var i=0; i<this.publications.length; i++) {
                        var type = this.publications[i].pretty_type;

                        if(this.peoplePublications[type]) {
                            this.peoplePublications[type].push(this.publications[i]);
                        }
                    }
                }
                // Store publications returned from the Kent API in the publications array
                else if (data.publications) {
                    this.publications = data.publications;
                    this.last_page = data.last_page;
                }
                // If call has been unsuccessful, store the error message to be displayed
                else if (!data.success) {
                    this.error_message = data.message;
                }
            })
            .catch(error => {
                this.error_message = error;
            });
        },
        update_limit(value) {
            this.noToDisplay = value;
            this.page_number = 1;
            this.call_the_API();
        },
        prettify(string) {
            // This method turns the type string into a pretty string
            return (
                string.charAt(0).toUpperCase() + string.slice(1).replace("_", " ")
            ).replace("Ed", "Edited ");
        },
        extract_the_content(html) {
            // Extracts the text from the citation which is an html string
            var parser = new DOMParser();
            var parsedHTML = parser.parseFromString(html, "text/html");
            return parsedHTML.getElementsByClassName("csl-entry")[0].innerText;
        },
        generate_link() {

            let url = 'https://kar.kent.ac.uk/cgi/search/advanced?';

            // Divisions
            // divisions=23000& : Singular
            // divisions=23000&divisions=25000&divisions=10000& : Multiple
            // divisions_match=EQ
            // divisions_merge=ALL

            if(this.division && this.division.use){
                let divisions_array = this.division.values.split(',');
                for(var i=0; i<divisions_array.length; i++) {
                    url += 'divisions=' + divisions_array[i] + '&';
                }
                url += 'divisions_match=' + this.division.match + '&';
                url += 'divisions_merge=' + this.division.merge + '&';
            }

            // Authors

            // Orcid

            if(this.authors && this.authors.use) {
            //     if(this.authors.type == 'email') {
            //         this.fetch_parameters["email"] = this.authors.values;
            //         this.fetch_parameters["email.match"] = this.authors.match;
            //         this.fetch_parameters["email.merge"] = this.authors.merge;
            //     } else if(this.authors.type == 'orcid') {
            //         this.fetch_parameters["orcid"] = this.authors.values;
            //         this.fetch_parameters["orcid.match"] = this.authors.match;
            //         this.fetch_parameters["orcid.merge"] = this.authors.merge;
            //     }
                this.show_link = false;
            }

            // Keywords
            // keywords=Physics of Quantum Materials
            // keywords=Physics%20of%20Quantum%20Materials
            // keywords_match=EQ
            // keywords_merge=ALL
    
            // if(this.taxonomies && this.taxonomies.uncontrolled_keywords.use){
            //     url += 'keywords=' + this.taxonomies.uncontrolled_keywords.value + '&';
            //     url += 'keywords_match=' + this.taxonomies.uncontrolled_keywords.match + '&';
            //     url += '"keywords_merge=' + this.taxonomies.uncontrolled_keywords.merge + '&';
            // }

            // Tags
            // tags=7& : Singular
            // tags=53&tags=54 : Multiple
            // tags_match=EQ
            // tags_merge=ALL

            if(this.taxonomies && this.taxonomies.kent_web_tag.use){
                url += 'tags=' + this.taxonomies.kent_web_tag.value + '&';
                url += 'tags_match=' + this.taxonomies.kent_web_tag.match + '&';
                url += 'tags_merge=' + this.taxonomies.kent_web_tag.merge + '&';
            }

            // Signature Theme
            // signature_theme=3
            // signature_theme_match=EQ
            // signature_theme_merge=ALL

            if(this.signature_theme && this.signature_theme.use){
                url += 'signature_theme=' + this.signature_theme.value + '&';
                url += 'signature_theme_match=' + this.signature_theme.match + '&';
                url += '"signature_theme_merge=' + this.signature_theme.merge + '&';
            }

            // Type
            // type=article&
            // type_match=EQ
            // type_merge=ALL
            if(this.people_profile == false) {
                if(this.publication_type && this.publication_type.value.length > 0) {
                    if(this.publication_type.value !== 'all') {
                        url += 'type=' + this.publication_type.value + '&';
                        url += 'type_match=' + this.publication_type.match + '&';
                        url += 'type_merge=' + this.publication_type.merge + '&';
                    }
                }
            }

            // Order the results
            // order=date : by year (oldest first)
            // order=-date : by year (most recent first)
            // order=creators_name%2F-date%2Ftitle : by author's name
            // order=title%2Fcreators_name%2F-date : by title.
        
            if(this.sort) {
                url += 'order=' + this.sort
            }
            
            this.link = url;

        },
        // Pagination controls
        go_to_previous_page() {
            this.page_number--;
            this.call_the_API();
        },
        go_to_next_page() {
            this.page_number++;
            this.call_the_API();
        },
        set_page_number(number) {
            // Handle whether the left or right '...' was clicked
            if (number === "l") {
                this.page_number -= Math.floor(this.maximum_no_pages / 2);
            } else if (number === "r") {
                this.page_number += Math.ceil(this.maximum_no_pages / 2);
            } else {
                this.page_number = number;
            }
            this.call_the_API();
        },
        set_is_start(bool) {
            this.near_start = bool;
        },
        set_is_end(bool) {
            this.near_end = bool;
        },
        set_publication_type_title() {
            // Sets the title telling the page visitor what type of content they are seeing
            var pub_types = this.publication_type.value.split(",");
            if(pub_types.length == 0 ) {
                this.publication_type_title = 'All';
            } else if(pub_types.length > 1) {
                this.publication_type_title = null;
            } else {
                switch(this.publication_type.value) {
                    case 'artefact':
                        this.publication_type_title = 'Artefacts';
                        break;
                    case 'article':
                        this.publication_type_title = 'Articles';
                        break;
                    case 'audio':
                        this.publication_type_title = 'Audio';
                        break;
                    case 'book':
                        this.publication_type_title = 'Books';
                        break;
                    case 'book_section':
                        this.publication_type_title = 'Book sections';
                        break;
                    case 'composition':
                        this.publication_type_title = 'Composition';
                        break;
                    case 'conference_item':
                        this.publication_type_title = 'Conferences or workshop items';
                        break;
                    case 'confidential_report':
                        this.publication_type_title = 'Confidential reports';
                        break;
                    case 'dataset':
                        this.publication_type_title = 'Datasets / databases';
                        break;
                    case 'design':
                        this.publication_type_title = 'Designs';
                        break;
                    case 'device':
                        this.publication_type_title = 'Devices';
                        break;
                    case 'edbook':
                        this.publication_type_title = 'Edited books';
                        break;
                    case 'edjournal':
                        this.publication_type_title = 'Edited journals';
                        break;
                    case 'experiment':
                        this.publication_type_title = 'Experiments';
                        break;
                    case 'image':
                        this.publication_type_title = 'Images';
                        break;
                    case 'internet':
                        this.publication_type_title = 'Internet publications';
                        break;
                    case 'monograph':
                        this.publication_type_title = 'Monographs';
                        break;
                    case 'other':
                        this.publication_type_title = 'Other';
                        break;
                    case 'patent':
                        this.publication_type_title = 'Patents';
                        break;
                    case 'performance':
                        this.publication_type_title = 'Performances';
                        break;
                    case 'research_report':
                        this.publication_type_title = 'Research reports (external)';
                        break;
                    case 'review':
                        this.publication_type_title = 'Reviews';
                        break;
                    case 'scholarlyed':
                        this.publication_type_title = 'Scholarly editions';
                        break;
                    case 'exhibition':
                        this.publication_type_title = 'Shows / exhibitions';
                        break;
                    case 'software':
                        this.publication_type_title = 'Software';
                        break;
                    case 'thesis':
                        this.publication_type_title = 'Thesis';
                        break;
                    case 'video':
                        this.publication_type_title = 'Visual media'
                        break;
                    default:
                        this.publication_type_title = 'All';
                }
            }
        }
    },
    created() {
        this.selected = this.limit;
        this.call_the_API();
        this.set_publication_type_title();
    },
    beforeDestroy() {
        localStorage.removeItem('karArray-' + this.panel_number);
    }
};
</script>